
<template lang="pug">
.flex.items-center.shifts-header
  SelectStore.q-mx-sm(
    :storeCode="storeCode"
    :floorCode="floorCode"
    inverted
    @change="onChangeStore"
  )

  SelectDate.q-mx-sm(
    :value="date"
    buttons
    inverted
    @change="onChangeDate"
  )

</template>

<script>
import SelectStore from 'components/SelectStore'
import SelectDate from 'components/SelectDate'

export default {
  components: {SelectStore, SelectDate},

  props: {
    storeCode: String,
    floorCode: String,
    date:      String,
  },

  methods: {
    onChangeStore(storeCode, floorCode) {
      this.$store.commit('route', {params: {storeCode, floorCode}})
    },

    onChangeDate(date) {
      this.$store.commit('route', {params: {date}})
    },
  },
}
</script>

<style lang="sass">
.shifts-header .q-select,
.shifts-header .q-datetime-input
  box-shadow: none !important
  padding: 0 !important

.shifts-header .q-btn
  box-shadow: none !important

</style>
